<template>
    <Detalhes :titulo="'Assinatura'" @aoSalvar="salvarAssinatura" @aoSair="sairAssinatura" :exibirLoader="exibirLoader">
        <div class="flex justify-between items-center mb-4">
            <div class="flex flex-wrap gap-2 justify-start items-center mt-4">
                <button  class="bg-[#ff4d4f33] text-[#FF4D4F] rounded-full w-16 h-12 flex items-center justify-center" @click="reset">
                    <span class="material-symbols-outlined">ink_eraser</span>
                </button>
                <button class="bg-[#0000000f] text-[#1C1B1F] rounded-full w-16 h-12 flex items-center justify-center" @click="desfazer()">
                    <span class="material-symbols-outlined">undo</span>
                </button>
            </div>
            <div class="flex flex-wrap gap-1 justify-start items-center mt-4">
                <button class="bg-[#BFBFBF] text-[#1C1B1F] rounded-full w-16 h-12 flex items-center justify-center gap-1 px-7">
                    <span class="bg-[#FF4D4F] rounded-full p-1.5"></span>
                    <span class="material-symbols-outlined">stylus_note</span>
                </button>
            </div>
        </div>
        <div class="flex flex-col justify-center items-center mb-4 landscape:flex-row">
            <VueSignaturePad class="canvas-detalhes" :width="`${larguraDaTela}px`" height="250px" ref="signaturePad" />
        </div>
        <div class="flex items-center text-azul-info justify-center">
            <Icone :nome="'stylus_note'" /> <span>Assine na área indicada</span>
        </div>
        <div class="flex flex-col justify-start items-start gap-2 mb-8 px-4">
            <h4 class="font-semibold mt-4 mb-2">Informações da assinatura</h4>
            <label class="font-medium" for="signatario">Nome</label>
            <input type="text" name="signatario" id="signatario" class="input-info"
                placeholder="Informe o nome do signatário" v-model="nomeSignatario">
            <label class="font-medium" for="numetoDocumento">Documento</label>
            <input type="text" name="numetoDocumento" id="numetoDocumento" class="input-info" maxlength="14"
                placeholder="Informe o documento do signatário" v-model="numeroDocumento" :onInput="validaNumber">
        </div>

        <div v-if="exigeConfirmacao" class="card flex flex-col gap-2">
            <div class="flex gap-x-2 items-center">
                <img class="w-6 h-6" src="@/assets/warning.png" alt="">
                <h3 class="text-azul-info font-semibold text-lg">Confirmação</h3>
            </div>
            <p>Você, como responsável no local, está ciente de todas as informações registradas no checklist e, ao confirmar, assume a responsabilidade por sua veracidade e precisão.</p>
            <button @click="confirmarDados(!confirmacaoSignatario)" 
                class="w-2/4 py-2 rounded-md mx-auto mt-2  flex gap-x-2 justify-center items-center"
                :class="confirmacaoSignatario ? 'border border-verde-sucesso text-verde-sucesso' : 'bg-verde-sucesso text-white border border-white'">
                <Icone v-if="confirmacaoSignatario" :nome="'check_circle'" />
                <p class="font-medium">{{ !confirmacaoSignatario ? 'Estou ciente' : 'Confirmado' }}</p>
            </button>
        </div>
    </Detalhes>
</template>

<script>
import { defineComponent } from 'vue';
import Detalhes from '@/components/Detalhes.vue';
import Icone from '@/components/Icone.vue';
import Rotas from '@/router/Rotas';
import ComponenteAssinaturaService from '@/services/componentes/ComponenteAssinaturaService';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import { GeoLocationService } from '@/services/GeolocationService';

export default defineComponent({
    name: 'DetalheFoto',
    components: {
        Detalhes,
        Icone
    },
    methods: {
        desfazer() {
            this.$refs.signaturePad.undoSignature();
        },
        reset() {
            this.$refs.signaturePad.clearSignature();
        },
        sairAssinatura() {
            FuncoesHelper.pushRouter(Rotas.RESUMO.nome, { identificador: this.identificador, localRealizacao: this.localRealizacao, modulo: this.modulo });
        },
        async salvarAssinatura() {
            if (this.exigeConfirmacao && !this.confirmacaoSignatario) {
                FuncoesHelper.notificar('error', 'Atenção', 'Confirme que está ciente das informações antes de salvar');
                return;
            }

            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            
            if (isEmpty) { 
                FuncoesHelper.notificar('error', 'Atenção', 'Favor assinar antes de salvar');
                return;
            }

            const { mimeType, byteSize } = FuncoesHelper.extrairMimetypeETamanhoImageData(data);
            
            this.exibirLoader = true;

            const coordenadas = await GeoLocationService.getCurrentPosition()
                .then(coords => coords)
                .catch(coords => coords);

            const unixTimestamp = Date.now();
            
            const assinaturaStore = this.$store.state.modulos.find(module => parseInt(module.idChecklistModulo) == parseInt(this.modulo)).assinaturas

            const assinatura = {
                signatario: this.nomeSignatario,
                numeroDocumento: this.numeroDocumento,
                nome: assinaturaStore.opcoes[this.signatario],
                descricao: `${this.nomeSignatario}@@${this.numeroDocumento}`,
                imagem: data,
                metadados: {
                    type: mimeType,
                    size: byteSize,
                    ...coordenadas,
                    horario: unixTimestamp
                }
            };

            if(this.exigeConfirmacao) {
                assinatura.ciente = this.confirmacaoSignatario;
            }

            const assinaturas = assinaturaStore.respostas || {};

            assinaturaStore.respostas = {
                ...assinaturas,
                [this.signatario]: assinatura
            };

            this.sairAssinatura();
        },
        confirmarDados(confirmado) {
            this.confirmacaoSignatario = confirmado;
        },
    },
    setup() {
        return ComponenteAssinaturaService.detalheAssinaturaSetup()
    }
});
</script>

<style scoped>
.input-info {
    @apply w-full border-b border-preto-padrao py-1.5 text-gray-900 placeholder:text-gray-300 sm:text-sm sm:leading-6 focus:outline-none focus:border-azul-info border-b-2 border-solid hover:border-blue-500;
}
</style>